import { Module } from 'vuex';

import { Filter } from 'qs_vuetify/src/types/models';
import { RootState } from 'qs_vuetify/src/types/states';

import { FiltersRestState } from '@/types/states';

import {
  buildRestActions,
  buildRestGetters,
  buildRestMutations,
  buildRestState,
} from 'qs_vuetify/src/plugins/rest';

export const state: FiltersRestState = buildRestState<Filter>('filters', {});

export const getters = buildRestGetters<Filter, FiltersRestState>();

export const actions = buildRestActions<Filter, FiltersRestState>();

export const mutations = buildRestMutations<Filter, FiltersRestState>();

export const filters: Module<FiltersRestState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
